<script>
    import { sgettext } from '../../i18n.js';
    import RichTextInput from '../RichTextInput.svelte';

    export let comment = '';
    export let purpose = '';
    export let purposeReadonly = true;
    export let purposeErrors = '';
    export let commentErrors= '';
    export let editorCommentLabel = '';
    export let editorCommentLabelTooltip = '';

    function commentChangeHandler(event) {
        comment = event.detail.text;
    }
</script>

<form>
  <div class="form-group">
    <label for="purposeField">
      {sgettext("$$S_NEW_VERSION_1$$")}*
      <a
        href="#"
        data-toggle="tooltip"
        title={sgettext(
          '$$TEXT_INTENDED_PERSONS_EXECUTES_WORK_APP$$'
        )}
        style="color:#ccc; margin-left:5px;"
      >
        <i class="fas fa-question-circle" />
      </a>
      {#if purposeErrors}
        <small class="text-danger">
          {purposeErrors}
        </small>
      {/if}
    </label>
    <textarea
      rows="3"
      class="form-control {purposeErrors ? 'is-invalid' : ''}"
      id="purposeField"
      placeholder={sgettext(
        '$$TEXT_INTENDED_PERSONS_EXECUTES_WORK_APP$$'
      )}
      readonly={purposeReadonly}
      bind:value={purpose}
    />
    <br />
    <RichTextInput
      {editorCommentLabelTooltip}
      {editorCommentLabel}
      {commentErrors}
      on:textChange={commentChangeHandler}
    />
  </div>
</form>

<style>
  label {
    margin: 7px 0px;
  }

  textarea[readonly] {
    opacity: 0.7;
    color: #000;
    background-color: #f5f5f5;
    overflow: scroll;
  }
</style>
